const SvgBack = () => {
  return (
    <svg width="16" height="28" viewBox="0 0 16 28" fill="none">
      <path
        d="M14 2L1.99996 14L14 26.0001"
        stroke="white"
        strokeWidth="2.83454"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SvgBack;
